export default __webpack_public_path__ + "static/DF_2013-68a7ae7655c6dca018d1340ba9b87a2e.pdf";